/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import { get, post, put } from '@/api/index'
import { baseUrl, url_LN, url_CM, url_LN_local } from '@/api/config'
import mySocket from '@/assets/js/mysocket'
import { sortTaskList } from '@/utils/common'
import VueCookies from 'vue-cookies';
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    'token': VueCookies.get('token'),
    'userName': VueCookies.get('userName'),
    'marketParam': {},
    'tradeTypeList': ['现货', '本周', '次周', '季度', '永续'],
    'tradeTypeObj': {'SS': '现货', 'CW': '本周', 'NW': '次周', 'CQ': '季度', 'CS': '永续', 'NQ': '次季'},
    'zhToEn': {'现货': 'SS', '本周': 'CW', '次周': 'NW', '季度': 'CQ', '永续': 'CS', '次季': 'NQ'},
    'currencyList': ['btc', 'eth', 'bch', 'eos', 'etc',  'xrp', 'ltc', 'trx'],
    'tableParamData': {},
    'msg': {'type': '提示'},
    'assetsTableHeader': ['币种','现货','期货','P_CW','P_NW','P_CQ','P_NQ','P_CS','F_CW','F_NW','F_CQ','F_NQ','F_CS','钱包','总币','总值','单价','本金(B)','本金(U)','资产比(%)'],
    'apiNameList': [],
    'assetBorrowData': {'ledger': [], 'borrow': []},
    'assetData': {},
    'assets': {},
    'taskList': [],
    'bourseList': {},
    'addTask': {},
    'strategyList': [],
    'currencyList': [],
    'abourseType': [],
    'bbourseType': [],
    'strategyParam': {},
    'dialogVisible': {'visible': false, 'ctaskVisible': false},
    'cTaskApiList': {},
    'addCtaskParam': {},
    'taskSelect': {},
    'cTaskList': {},
    'defaultParams': {},
    'id': {},
    'pyParamData': {},
    'taskConfigParam': {},
    'taskWebSocket': null,
    'taskIdList': [],
    'taskWbtTimer': {},
    'allTaskIdList': [],
    'elementSelect': {},
    'taskPosition': {},
    'taskRunIdList': [],
    'taskRunPriceCal': {},
    'taskCopyData': {},
    'assetChartData': {},
    'marketTableList': [],
    'layout': 3,
    'currencyNum': {},
    'currencyNumList': [],
    'taskBoxSelect': [],
    'statWebsocket': null,
    'statTimer': {},
    'checkAllFlag': false,
    'marketSocket': {},
    'taskInfoSocket': {},
    'apiChartData': {},
    'apiInterval': null,
    'taskCloseData': {},
    'taskPageFlag': 1,
    'taskTimer': {},
    'ctaskWidth': null,
    'taskChangeAble': [],
    'taskStatusList': {},
    'currencyChangeFlag': 'u',
    'unilateralKey': '',
    'signatrue': '',
    'userLevel': VueCookies.get('isSuper'),
    "uniSocket": {},
    "userSocket": {},
    "userChartData": {},
    "userStrategyId": sessionStorage.getItem('sidd'),
    "loadingFlag": true,
    "userPermissionList": ['userMain', 'user', 'userStatic'],
    "tempSocket": {},
    "unilSChartData": [],
    'userPermission': null,
    'defaultPermission': ['/login', '/home', '/user', '/guide', '/404']
  },
  mutations: {
    getToken(state, data) {
      state.token = data;
    },
    getUserName(state, data) {
      state.userName = data;
    },
    initMarketParam(state, data) {
      state.marketParam = data;
    },
    initApiNameList(state, data) {
      state.apiNameList = data;
    },
    initTaskList(state, data) {
      state.taskList = data;
    },
    initStrategyList(state, data) {
      state.strategyList = data;
    },
    initCurrencyList(state, data) {
      state.currencyList = data;
    },
    initAbourseType(state, data) {
      state.abourseType = data;
    },
    initBbourseType(state, data) {
      state.bbourseType = data;
    },
    initStrategyParam(state, data) {
      state.strategyParam = data;
    },
    cTaskApiList(state, data) {
      state.cTaskApiList = data;
    },
    initAddTaskObj(state, data) {
      state.addTask = data;
    },
    initTaskConfigParam(state, data) {
      state.taskConfigParam = data;
    },
    initTaskSocket(state, data) {
      state.taskWebSocket = data;
    },
    createTaskIdList(state, data) {
      state.taskIdList = data;
    },
    giveAllTaskIdList(state, data) {
      state.allTaskIdList = data
    },
    giveElementNode(state, data) {
      state.elementSelect = data
    },
    initTaskPosition(state, data) {
      state.taskPosition = data
    },
    giveRunTaskPrice(state, data) {
      state.taskRunPriceCal = data
    },
    initAssetChartData(state, data) {
      state.assetChartData = data
    },
    getMarketParam2(state, data) {
      state.marketTableList = data
    },
    setAssetLayout(state, data) {
      state.layout = data
    },
    setCurrencyNum(state, data) {
      state.currencyNum = data
    },
    setCurrencyNumList(state, data) {
      state.currencyNumList = data;
    },
    initStatSocket(state, data) {
      state.statWebsocket = data;
    },
    setStatTimer(state, data) {
      state.statTimer = data
    },
    setCheckBoxFlag(state, data) {
      state.checkAllFlag = data
    },
    initTaskBoxSelect(state, data) {
      state.taskBoxSelect = data;
    },

    setTaskCopyData(state, data) {
      state.taskCopyData = data
    },
    setApiChartData(state, data) {
      state.apiChartData = data
    },
    setApiInterval(state, data) {
      state.apiInterval = data
    },
    setTaskCloseData(state, data) {
      state.taskCloseData = data;
    },
    setTaskPageFlag(state, data) {
      state.taskPageFlag = data
    },
    setCtaskWidth(state, data) {
      state.ctaskWidth = data
    },
    setTaskChangeable(state, data) {
      state.taskChangeAble = data
    },
    setTaskStatusList(state, data) {
      state.taskStatusList = data
    },
    setCurrencyFlag(state, data) {
      state.currencyChangeFlag = data
    },
    setUnilateralKey(state, data) {
      state.unilateralKey = data
    },
    setUnilateralSig(state, data) {
      state.signatrue = data
    },
    setUnilateralLevel(state, data) {
      state.userLevel = data
    },
    setUserChartData(state, data) {
      state.userChartData = data;
    },
    setUserStrategyId(state, data) {
      state.userStrategyId = data;
    },
    setLoadingFlag(state, data) {
      state.loadingFlag = data;
    },
    setUnilSChartData(state, data) {
      state.unilSChartData = data;
    },
    setUserPromistion(state, data) {
      state.userPermission = data
    }
  },
  actions: {
    /**
     * 行情页面 api
     */

    // 获取行情参数
    getMarketParam({commit, state}) {
      let url = baseUrl + '/market/param/get';
      let param = { 'token': state.token };
      get(url, param).then(resp => {
        if (resp.code == 200) {
          commit('initMarketParam', resp.data);
        } else {
          this.$notify.error({
            message: resp.info,
            title: '提示',
            offset: 100
          })
        }
      })
    },

    // 修改行情参数
    changeMarketParam({commit, state}) {
      let url = baseUrl + '/market/put';
      state.marketParam['token'] = state.token;
      put(url, state.marketParam).then(resp => {
        if (resp.code === 200) {
        } else {
            Vue.prototype.$notify.info({
              message: resp.info,
              title: '提示',
              offset: 100
            })
        }
      }).catch(err => {
        console.warn(err);
      })
    },

    // 获取行情参数 copy
    getMarketParam1({commit, state}) {
      var url = baseUrl + '/market/param/get2';
      get(url, {'token': state.token}).then(resp => {
          if (resp.code == 200) {
            commit('getMarketParam2', resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
      })
    },

    /*  资产页面 api */

    // 获取 api 列表名称
    getApiList({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/api/name';
        var param = {
          'token': state.token,
          'all': 1
        };
  
        get(url, param).then(resp => {
          if (resp.code === 200) {
            if (resp.data.length !== 0) {
              state.id['apiId'] = resp.data[0].id;
              commit('initApiNameList', resp.data);
              resolve(resp.data, resp.data[0].bourse_id);
            }
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        });
      })
    },

    getApiDataList({commit, state}) {// new
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/api/name';
        var param = {
          'token': state.token,
          'all': 1
        };
  
        get(url, param).then(resp => {
          if (resp.code === 200) {
            if (resp.data.length !== 0) {
              resolve(resp.data);
            }
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        });
      })
    },

    // 创建资产 websocket
    createAssetSocket({commit, state}) {
      return new Promise((resolve, reject) => {
        let url = '/asset/get?token='+state.token;

        let assetWbt = new mySocket.MySocket(url, baseUrl);
        assetWbt.socket.onopen = function () {
          console.info(assetWbt.socket.url+':: 连接成功');
          state.assets['assetSocket'] = assetWbt;
          resolve(assetWbt);
        }
      })
    },

    /**
     * 任务页面
     */

     // 获取任务列表
    getTaskList({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/task/list';
        var param = {
          'token': state.token,
          'pagesize': 10,
          'page': 1
        };
        get(url, param).then(resp => {
          if (resp.code === 200) {
            
            var sort_task_list = resp.data;
            var task_len = sort_task_list.length;
            // 第一次排序 将相同的币种放到一起
            for (var i=0; i<task_len; i++) {
                var i_task_name = sort_task_list[i].params.currency_type;
                var k = i+1;
                for (var j=k; j<task_len; j++) {
                    var j_task_name = sort_task_list[j].params.currency_type;
                    if (i_task_name == j_task_name) {
                        [sort_task_list[k], sort_task_list[j]] = [sort_task_list[j], sort_task_list[k]];
                        break;
                    }
                }
            }
            // 第二次排序 按近期远期排序
            var new_task_list = sortTaskList(sort_task_list, state.currencyNum)
            commit('initTaskList', new_task_list);

            state.allTaskIdList = [];
            state.taskRunIdList = [];
            for (var i=0; i<sort_task_list.length; i++) {
              // 所有 id 列表
              state.allTaskIdList.push(sort_task_list[i].id)
              if (sort_task_list[i].status == 2) {// 运行中的任务id列表
                state.taskRunIdList.push(sort_task_list[i].id)
              }
            }

            resolve(sort_task_list);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        })
      })
    },

    // 获取交易所
    getBourseList({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/bourse/get';
        var param = {'token': state.token};
        get(url, param).then(resp => {
          if (resp.code === 200) {
            state.bourseList['bourse'] = resp.data; 
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        })
      })
    },

    // 获取交易类型
    getaBourseType({commit, state}) {
      var url = baseUrl + '/transactionType/get';
      var param = {
        'token': state.token,
        'bourseId': state.addTask.a_bourse
      };
      get(url, param).then(resp => {
        if (resp.code === 200) {
          state.bourseList['a_transaction_type'] = resp.data;
          commit('initAbourseType', resp.data);
        } else {
          Vue.prototype.$notify.error({
            message: resp.info,
            title: '提示',
            offset: 100
          })
        }
      })
    },

    getbBourseType({commit, state}) {
      var url = baseUrl + '/transactionType/get';
      var param = {
        'token': state.token,
        'bourseId': state.addTask.b_bourse
      };
      
      get(url, param).then(resp => {
        if (resp.code === 200) {
          state.bourseList['b_transaction_type'] = resp.data;
          commit('initBbourseType', resp.data);
        } else {
          Vue.prototype.$notify.error({
            message: resp.info,
            title: '提示',
            offset: 100
          })
        }
      })
    },

    // 获取策略列表
    getStrategyList({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/strategy/home';
        var param = {'token': state.token};
        get(url, param).then(resp => {
          if (resp.code === 200) {
            commit('initStrategyList', resp.data);
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        })
      })
    },

    // 获取币种
    getCurrency({commit, state}) {
      var url = baseUrl + '/currencyType/get';

      var param = {
        'token': state.token,
        'aTransactionType': state.addTask.a_transaction_type,
        'bTransactionType': state.addTask.b_transaction_type
      };
      var strategy_len = Object.keys(state.strategyParam.taskBaseParams);
      if (strategy_len.length !== 0) {// strategyParam 有值
        if (!state.strategyParam.taskBaseParams.hasOwnProperty('a_transaction_type')) {// 如果 strategyParam 没有 key=a_transaction_type
          delete param['aTransactionType'];
        }
        if (!state.strategyParam.taskBaseParams.hasOwnProperty('b_transaction_type')) {// 如果 strategyParam 没有 key=b_transaction_type
          delete param['bTransactionType'];
        }
      }
      get(url, param).then(resp => {
        if (resp.code === 200) {
          commit('initCurrencyList', resp.data);
        } else {
          Vue.prototype.$notify.error({
            message: resp.info,
            title: '提示',
            offset: 100
          })
        }
      })
    },

    // 获取策略默认参数
    getStrategyParam({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/strategy/params/get';
        var param = {
          'token': state.token,
          'strategyId': state.addTask.strategySelect
        };
        get(url, param).then(resp => {
          if (resp.code === 200) {
            commit('initStrategyParam', {})
            commit('initStrategyParam', resp.data)
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        })
      })
    },

    // 获取策略默认参数2 策略调用
    getStrategyParam2({commit, state}) {
      return new Promise((resolve, reject) => {
        var url = baseUrl + '/strategy/params/get2';
        var param = {
          'token': state.token,
          'strategyId': state.addTask.strategySelect || 24
        };
        get(url, param).then(resp => {
          if (resp.code === 200) {
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: '提示',
              offset: 100
            })
          }
        })
      })
    },

    // 获取子任务API列表
    getCtaskList({commit, state}) {
      var url = baseUrl + '/task/available/api/get';
      var param = {
        'token': state.token,
        'taskId': state.id.taskId,
        'status': '1' 
      };
      get(url, param).then(resp => {
        if (resp.code === 200) {
          for (var i in resp.data) {
            if (resp.data[i].length == 0) {
              delete resp.data[i];
            }
          }
          commit('cTaskApiList', resp.data);
        } else {
          Vue.prototype.$notify.error({
            message: resp.info,
            title: '提示',
            offset: 100
          })
        }
      })
    },

    // 获取交易类型
    getCurrencyNum({commit, state}) {
      var url = 'http://107.149.104.7:9999/internal/get_delivery_code';
      return new Promise((resolve, reject) => {
        get(url).then(resp => {
          if (resp.code == 200) {
            commit('setCurrencyNum', resp.data);
            var currencyNumList = [];
            for (var i in resp.data) {
              currencyNumList.push(resp.data[i])
            }
            commit('setCurrencyNumList', currencyNumList);
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: resp.info,
              title: "提示",
              offset: 100
            })
          }
        })
      })
    },

    // 创建任务 websocket
    createTaskSocket({commit, state}) {
      // return new Promise((resolve, reject) => {
      //   let url = '/websocket';
      //   let baseUrl = url_CM + '/taskServer';
      //   // let taskWbt = new mySocket.MySocket(url, baseUrl);
      //   // taskWbt.socket.onopen = function () {
      //   //   console.info(taskWbt.socket.url+':: 连接成功');
      //   //   state.taskWebSocket = taskWbt;
      //   //   resolve(taskWbt)
      //   // }

      //   let taskWbt = new mySocket1.MySocket(url, baseUrl);
      //   taskWbt.socket.onopen = function () {
      //     console.info(taskWbt.socket.url+':: 连接成功');
      //     state.taskWebSocket = taskWbt;
      //     resolve(taskWbt)
      //   }
      // })
    },

    /**
     * 统计页面
     */

    // 创建统计页面 websocket
    createStatisticSocket({commit, state}) {
      return new Promise((resolve, reject) => {
        // 192.168.1.70 47.56.71.41
        var url = url_LN + "/web/get/order/total"
        var statisticWbt = new mySocket.MySocket('', url);
        statisticWbt.socket.onopen = function () {
          console.info(statisticWbt.socket.url+':: 连接成功');
          commit('initStatSocket', statisticWbt)
          resolve(statisticWbt);
        }
      })
    },

    /**
     * k线 图表
     */

    // K线 时间段查询
    getKTime({commit, state}, param) {
      return new Promise((resolve, reject) => {
        var url = url_LN + '/web/get/distance/days';
  
        get(url, param).then(resp => {
          if (resp.code == 200) {
            resolve(resp.data);
          } else {
            Vue.prototype.$notify.error({
              message: 'k线时间查询 Message: '+resp.info,
              title: '提示',
              offset: 100,
              duration: 1000
            })
          }
        })
      })
    }, 

    /**
     * api 页面
     */
    // 获取资产快照
    getChartData({commit, state}) {
      var url = baseUrl + '/asset/changing/rate/get';
      var param = {
          'token': state.token,
      };

      get(url, param).then(resp => {
          if (resp.code == 200) {
              commit('setApiChartData', resp.data);
          } else {
              Vue.prototype.$notify.error({
                  message: resp.info,
                  title: '提示',
                  offset: 100,
                  duration: 1000
              })
            }
        })
      },

    // 获取权限
    getUserPermission({commit, state}) {
      var url = url_LN_local + '/display/permission/data'

      var param = {
        'token': state.token
      }

      return get(url, param).then(res => {
          if(res.code === 200) {
            commit('setUserPromistion', res.data)
          } else {
            Vue.prototype.$notify.error({
              message: '获取权限失败',
              title: '提示',
              offset: 100,
              duration: 1000
            })
          }
        }).catch((error) => {
          Vue.prototype.$notify.error({
              message: '获取权限失败',
              title: '提示',
              offset: 100,
              duration: 1000
          })
          throw new Error(error)
        })
    }
  },
  plugins: [
    // createPersistedState({
    //   reducer(val) {
    //     return {
    //       token: val.token
    //     }
    //   }
    // })
  ]
})
